import { render } from "./SMEdocument.vue?vue&type=template&id=4c64d85b&scoped=true"
import script from "./SMEdocument.vue?vue&type=script&lang=js"
export * from "./SMEdocument.vue?vue&type=script&lang=js"

import "./SMEdocument.vue?vue&type=style&index=0&id=4c64d85b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c64d85b"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QLinearProgress,QCard,QCardSection,QCheckbox,QBtn});
